export const pipelineData = [
  {
    key:"1",
    Pipeline_Name: "Sales",
    Total_Deal_Value: "$4,50,000",
    No_of_Deals: "315",
    Stages: "Won",
    Created_Date: "14 Jan 2024",
    Status: "Active",
  },
  {
    key:"2",
    Pipeline_Name: "Marketing",
    Total_Deal_Value: "$3,15,000",
    No_of_Deals: "447",
    Stages: "In Pipeline",
    Created_Date: "21 Jan 2024",
    Status: "Active",
  },
  {
    key:"3",
    Pipeline_Name: "Calls",
    Total_Deal_Value: "$8,40,000",
    No_of_Deals: "654",
    Stages: "Won",
    Created_Date: "20 Feb 2024",
    Status: "Active",
  },
  {
    key:"4",
    Pipeline_Name: "Email",
    Total_Deal_Value: "$6,10,000",
    No_of_Deals: "545",
    Stages: "Conversation",
    Created_Date: "15 Mar 2024",
    Status: "Active",
  },
  {
    key:"5",
    Pipeline_Name: "Chats",
    Total_Deal_Value: "$4,70,000",
    No_of_Deals: "787",
    Stages: "Won",
    Created_Date: "12 Apr 2024",
    Status: "Active",
  },
  {
    key:"6",
    Pipeline_Name: "Operational",
    Total_Deal_Value: "$5,50,000",
    No_of_Deals: "787",
    Stages: "Follow Up",
    Created_Date: "20 May 2024",
    Status: "Active",
  },
  {
    key:"7",
    Pipeline_Name: "Collabrative",
    Total_Deal_Value: "$5,00,000",
    No_of_Deals: "315",
    Stages: "Won",
    Created_Date: "06 Jul 2024",
    Status: "Inactive",
  },
  {
    key:"8",
    Pipeline_Name: "Differentiate",
    Total_Deal_Value: "$4,50,000",
    No_of_Deals: "478",
    Stages: "Schedule servise",
    Created_Date: "02 Sep 2024",
    Status: "Active",
  },
  {
    key:"9",
    Pipeline_Name: "Interact",
    Total_Deal_Value: "$6,20,000",
    No_of_Deals: "664",
    Stages: "Won",
    Created_Date: "15 Nov 2024",
    Status: "Active",
  },
  {
    key:"10",
    Pipeline_Name: "Identify",
    Total_Deal_Value: "$7,40,000",
    No_of_Deals: "128",
    Stages: "Lost",
    Created_Date: "10 Dec 2024",
    Status: "Active",
  },
];
